import { AppRouteProps } from "@harea/component";
import React from "react";
import { DetailsRoutes } from "./views/details/DetailsRoutes";
import { DepartmentsRoutes } from "./views/departments/DepartmentsRoutes";
import { EstablishmentsRoutes } from "./views/establishments/EstablishmentsRoutes";
import { OrganizationBenefitsRoutes } from "./views/benefits/OrganizationBenefitsRoutes";
import { UsersRoutes } from "./views/users/UsersRoutes";
import { RolesRoutes } from "./views/roles/RolesRoutes";
import { SettingsRoutes } from "./views/settings/SettingsRoutes";
import { HeuresSupplementairesRoutes } from "./views/heures-supplementaires/HeuresSupplementairesRoutes";

const MyOrganizationContainer = React.lazy(() => import('./container/MyOrganizationContainer'))

export const MyOrganizationRoutes: Array<AppRouteProps> = [
    {
        path: "my-organization",
        element: <MyOrganizationContainer />,
        children: [
            ...DetailsRoutes,
            ...RolesRoutes,
            ...DepartmentsRoutes,
            ...EstablishmentsRoutes,
            ...OrganizationBenefitsRoutes,
            ...UsersRoutes,
            ...HeuresSupplementairesRoutes,
            ...SettingsRoutes,
        ],
    },
]